import { useInbox } from '../../../../contexts/InboxProvider';
import { byLabel } from '../../../../utils/journalUtils';
import Listbox from '../../../Listbox';

const getListItems = (caregivers: SystemUser[]): ListboxItem[] => {
  return caregivers.map((caregiver) => ({
    id: caregiver.guid,
    label: `${caregiver.givenName} ${caregiver.familyName}`,
    value: caregiver
  }));
};

export default function CaregiverPicker() {
  const { caregivers, selectedCaregiver, selectCaregiverFilter } = useInbox();

  return (
    <CaregiverPickerPure
      caregivers={caregivers}
      selectedCaregiver={selectedCaregiver}
      onSelectCaregiver={selectCaregiverFilter}
      label="Filtrera på vårdgivare"
    />
  );
}

type CaregiverPickerPureProps = {
  caregivers: SystemUser[];
  selectedCaregiver?: SystemUser;
  defaultSelected?: SystemUser;
  onSelectCaregiver: (caregiver: SystemUser) => void;
  label?: string;
};

export function CaregiverPickerPure({
  caregivers,
  defaultSelected,
  onSelectCaregiver,
  label = 'Välj vårdgivare'
}: CaregiverPickerPureProps) {
  const doctors = caregivers.filter((caregiver) => caregiver.authorities?.includes('caregiver'));
  const nurses = caregivers.filter((caregiver) => caregiver.authorities?.includes('nurse'));
  const doctorItems = getListItems(doctors);
  const nurseItems = getListItems(nurses);
  const caregiversList: ListboxItem[] = [];

  doctorItems.sort(byLabel);
  nurseItems.sort(byLabel);

  caregiversList.push({ id: '', label });

  if (doctorItems.length) {
    caregiversList.push({ id: '1', isCategory: true, label: 'PAL' });
    caregiversList.push(...doctorItems);
  }

  if (nurseItems.length) {
    caregiversList.push({ id: '2', isCategory: true, label: 'PAS' });
    caregiversList.push(...nurseItems);
  }

  if (!doctorItems.length && !nurseItems.length) {
    caregiversList.push({ id: 'empty', label: 'Inga vårdgivare tillgängliga', disabled: true });
  }

  return (
    <Listbox
      defaultSelected={caregiversList.find((c) => c.id === defaultSelected?.guid)}
      items={caregiversList}
      onSelectItem={(caregiver) => {
        onSelectCaregiver(caregiver.value);
      }}
    />
  );
}
